export const environment = {
  production: true,
  connection: {
    name: 'LH Südburgenland Softline',
    host: 'https://softline.rlhsued.at/',
    port: 443,
    basePath: '/api'
  },
  androidUpdateRepository: ''
};
